// Change this:
export const API_BASE_URL = 'https://erp.learninghub.ind.in';

// To this (assuming your local backend is on port 5000):
// export const API_BASE_URL = 'http://localhost:5000';

